import CrossReferences from './cross-reference-items-list-screen.vue';

export default {
    components: {
        'cross-references': CrossReferences
    },

    data: function () {
        return {
            loading: false,
            appId: this.$route.params.id ?? 0,
            senderId: this.$route.params.senderId ?? 0,
            receiverId: this.$route.params.receiverId ?? 0,
            tableName: this.$route.params.tableName ?? "",
            model: this.emptyModel()
        }
    },

    computed: {

    },

    methods: {
        refreshScreen() {
            this.appId = this.$route.params.id ?? 0;
            this.senderId = this.$route.params.senderId ?? 0;
            this.receiverId = this.$route.params.receiverId ?? 0;
            this.tableName = this.$route.params.tableName ?? "";
            this.onLoadModelDataSource();
        },

        emptyModel() {
            return {
                AppId: 0,
                SenderId: 0,
                SenderName: '',
                SenderCode: 0,
                ReceiverId: 0,
                ReceiverName: '',
                ReceiverCode: 0,
                TableName: ''
            }
        },

        async onLoadModelDataSource() {
            try {
                this.loading = true;

                let url = '/api/ui/cross_reference_applications/load/' + this.appId + '/' + this.senderId + '/' + this.receiverId + '/' + this.tableName;
                let response = await this.$http.get(url);
                this.model = response.body;

                this.$refs.crossReferences.channelSettings = {
                    SenderId: this.model.SenderId,
                    SenderName: this.model.SenderName,
                    SenderCode: this.model.SenderCode,
                    ReceiverId: this.model.ReceiverId,
                    ReceiverName: this.model.ReceiverName,
                    ReceiverCode: this.model.ReceiverCode,
                    TableName: this.model.TableName
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },
    },

    watch: {
        // Reload data if the route changed manually from browser address bar
        $route: 'refreshScreen'
    },

    mounted: function () {
        this.refreshScreen();
    }
}